module.exports = __webpack_public_path__ + "static/media/Sports_Club_Day_Poster.ac1b917a.jpg";